import { Box, Button, Menu, MenuItem, Paper, Switch, Typography, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

const UserDetail = () => {
  const params = useParams();
  const isNonMobile = useMediaQuery('(min-width:600px)');

  // State
  const [isActive, setIsActive] = useState(true); // 사용 여부 상태값
  const [anchorEl, setAnchorEl] = useState(null); // 메뉴 팝업 상태값
  const isMenuOpen = Boolean(anchorEl);

  // Handlers
  const handleSwitchToggle = () => {
    setIsActive(prev => !prev);
  };

  const handleAgentClick = event => {
    setAnchorEl(event.currentTarget); // 메뉴 팝업 열기
  };

  const handleMenuClose = () => {
    setAnchorEl(null); // 메뉴 팝업 닫기
  };

  return (
    <Box sx={{ p: 2, bgcolor: '#f5f5f5' }}>
      <Paper sx={{ p: isNonMobile ? 3 : 2, borderRadius: 2 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          유저 수정
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <Box display="flex" justifyContent="flex-start" gap={5}>
            <Typography variant="body1">유저 번호: </Typography>
            <Typography variant="body1">{params.userId || '515744'}</Typography>
          </Box>
          <Box display="flex" justifyContent="flex-start" gap={5}>
            <Typography variant="body1">소속 에이전트: </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Typography variant="body1" textAlign={'center'}>
                ch1234
              </Typography>
              <Button onClick={handleAgentClick} variant="outlined" sx={{ cursor: 'pointer' }}>
                ch1234
              </Button>
            </Box>
          </Box>
          <Box display="flex" justifyContent="flex-start" gap={5}>
            <Typography variant="body1">아이디: </Typography>
            <Typography variant="body1">space_devtest</Typography>
          </Box>
          <Box display="flex" justifyContent="flex-start" gap={5}>
            <Typography variant="body1">현재 보유 금액: </Typography>
            <Typography variant="body1">0.0 원</Typography>
          </Box>
          <Box display="flex" justifyContent="flex-start" gap={5} alignItems="center">
            <Typography variant="body1">사용 여부</Typography>
            <Switch checked={isActive} onChange={handleSwitchToggle} color="primary" />
          </Box>
          <Box mt={4} display="flex" justifyContent="center">
            <Button
              variant="contained"
              fullWidth
              sx={{
                bgcolor: '#8e44ad',
                color: 'white',
                '&:hover': {
                  bgcolor: '#732d91',
                },
              }}
            >
              저장
            </Button>
          </Box>
        </Box>
      </Paper>

      {/* 메뉴 팝업 */}
      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem onClick={handleMenuClose}>수정</MenuItem>
        <MenuItem onClick={handleMenuClose}>지급 내역</MenuItem>
        <MenuItem onClick={handleMenuClose}>충전 내역</MenuItem>
        <Box
          sx={{
            borderTop: '1px solid #ccc',
            mt: 1,
            pt: 1,
          }}
        >
          <Typography variant="subtitle2" sx={{ pl: 2, color: 'purple', fontWeight: 'bold' }}>
            유저
          </Typography>
          <MenuItem onClick={handleMenuClose}>유저 목록</MenuItem>
          <MenuItem onClick={handleMenuClose}>지급 내역</MenuItem>
        </Box>
      </Menu>
    </Box>
  );
};

export default UserDetail;
